var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNotificationRightArrow = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 8,
    viewBox: "0 0 10 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.81719 4.19257C9.8753 4.13453 9.9214 4.0656 9.95285 3.98972C9.9843 3.91385 10.0005 3.83252 10.0005 3.75038C10.0005 3.66825 9.9843 3.58692 9.95285 3.51105C9.9214 3.43517 9.8753 3.36624 9.81719 3.3082L6.69219 0.183196C6.63412 0.125128 6.56518 0.0790655 6.48931 0.0476391C6.41344 0.0162127 6.33212 3.64397e-05 6.25 3.64433e-05C6.16788 3.64469e-05 6.08656 0.0162127 6.01069 0.0476391C5.93482 0.0790655 5.86588 0.125128 5.80781 0.183196C5.74974 0.241265 5.70368 0.310204 5.67225 0.386074C5.64083 0.461945 5.62465 0.543263 5.62465 0.625385C5.62465 0.707506 5.64083 0.788824 5.67225 0.864695C5.70368 0.940565 5.74974 1.0095 5.80781 1.06757L7.86641 3.12538L0.625 3.12538C0.45924 3.12538 0.300268 3.19123 0.183058 3.30844C0.0658478 3.42565 -1.71179e-07 3.58462 -1.63933e-07 3.75038C-1.56687e-07 3.91615 0.0658479 4.07512 0.183058 4.19233C0.300268 4.30954 0.45924 4.37538 0.625 4.37538L7.86641 4.37538L5.80781 6.4332C5.69054 6.55047 5.62465 6.70953 5.62465 6.87538C5.62465 7.04124 5.69054 7.2003 5.80781 7.31757C5.92509 7.43485 6.08415 7.50073 6.25 7.50073C6.41585 7.50073 6.57491 7.43485 6.69219 7.31757L9.81719 4.19257Z",
    fill: "#3A82F0"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNotificationRightArrow);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/notification_right_arrow.9db1ccc43dba40dc69bcd2aa53ac58fc.svg";